import React, { useMemo } from "react";
import Config from "../../Config/Config.js";
import APIService from "../../Service/APIService";
import { Button, Input, Modal, Flex, Spin, Pagination, Skeleton } from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  SortDescendingOutlined,
  SortAscendingOutlined,
} from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import TitleBar from "../../common/title-bar/title-bar.js";
import CommonTable from "../../common/table/index.js";
import { tableHeadersDistributorDashboard } from "../Utils/Constants.js";
import { useScreen } from "../Utils/Screens.js";
import { colors } from "../../theme/colors.js";
import CommonButton from "../../common/button/button.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";

const components = {
  header: {
    cell: ({ style, ...restProps }) => (
      <th
        {...restProps}
        style={{
          ...style,
          backgroundColor: "#000a7b",
          color: "#fff",
        }}
      />
    ),
  },
};

const DistributorDashboard = () => {
  const { user, isReady } = useAuth();
  const [columns, setColumns] = React.useState([]);
  const [distributorData, setDistributorData] = React.useState([]);
  const [userType, setUserType] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(20);
  const [totalCount, setTotalCount] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const requestIdRef = React.useRef(0);

  const isPhone = !useScreen("sm");

  const [selectedSegment, setSelectedSegment] = useState("Active");

  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
    setCurrentPage(1);
  };


  const generateSchema = () => {
    const schema = Config.ColumnConfigs.DistributorDashboard;
    const columns = [];
    for (const cur of schema) {
      if (
        cur.isDisplayed &&
        cur.isSearchable &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        // console.log("Inside AccountName Column");
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : "0" || 0) === "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              console.log("backend name: ", cur.backendName);
              console.log("strng total: ", a[`${cur.backendName}`]);
              console.log(
                "total: ",
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
              return (
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                ) -
                Number(
                  b[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            } else {
              console.log("invalid");
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (
        cur.isDisplayed &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`] ? a[`${cur.backendName}`] : 0) ===
              "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              return (
                a[`${cur.backendName}`].replace("$", "").replace(",", "") -
                b[`${cur.backendName}`].replace("$", "").replace(",", "")
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (cur.isDisplayed && cur.isSpecial) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (cur.isDisplayed && cur.isFormatter) {
        const obj = createFormatter(cur);
        columns.push(obj);
      }
    }
    console.log("Columns: ", columns);
    return columns;
  };

  const viewFunc = (index, record) => {
    return (
      <Button type="primary" style={{ background: "#ff9202" }}>
        <Link to={`/Distributor/${record.ID}`}>View</Link>
      </Button>
    );
  };

  const createFormatter = (cur) => {
    switch (cur.formatterType) {
      case "redirectButton": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => viewFunc(index, record),
        };
      }
    }
  };

  const formatMoney = (value) => {
    const numeric = Number.parseFloat(
      String(value ?? 0).replace(/[^0-9.-]+/g, "")
    );
    if (Number.isNaN(numeric)) return "$0.00";
    return `$${numeric.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    })}`;
  };

  const normalizeDistributors = (rows) => {
    return (rows || []).map((ele) => ({
      ...ele,
      SalesYTD: formatMoney(ele?.SalesYTD),
      SalesMTD: formatMoney(ele?.SalesMTD),
    }));
  };

  const buildDistributorUrl = (page, size) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("pageSize", String(size));
    if (selectedSegment === "Active") {
      params.set("status", "active");
    } else if (selectedSegment === "Inactive") {
      params.set("status", "inactive");
    }
    return `getdistributordashboard?${params.toString()}`;
  };

  const fetchDistributorsPage = async (page, size) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        buildDistributorUrl(page, size)
      );
      if (requestId !== requestIdRef.current) return;
      const payload = response?.data ?? {};
      const rows = payload?.data ?? [];
      const total = payload?.totalCount ?? rows.length;
      const pages =
        payload?.totalPages ?? Math.ceil(total / (size || 1));
      setDistributorData(normalizeDistributors(rows));
      setTotalCount(total);
      setTotalPages(pages);
    } catch (err) {
      console.error("Failed to fetch distributors dashboard data:", err);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };
  React.useEffect(() => {
    setColumns(generateSchema());
  }, []);

  React.useEffect(() => {
    if (!isReady) return;
    if (user?.Type === "Manufacturer" || user?.Type === "Account") {
      window.location.href = "/";
      return;
    }
    setUserType(user?.Type || "");
    if (searchKeyword !== "") return;
    fetchDistributorsPage(currentPage, pageSize);
  }, [isReady, user?.Type, searchKeyword, currentPage, pageSize, selectedSegment]);

  const [showNewDistributorModal, setShowNewDistributorModal] =
    React.useState(false);
  const [modalData, setModalData] = React.useState({});
  const navigate = useNavigate();

  const openNewAccountModal = (record) => {
    console.log("New Dist Modal Opened: ", record);
    setModalData(record);
    setShowNewDistributorModal(true);
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setShowNewDistributorModal(false);
  };

  const handleInputChange = (e) => {
    setDistributorName(e.target.value);
  };

  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const [distributorName, setDistributorName] = useState("");
  const handleOk = async () => {
    const trimmedDistributorName = distributorName.trim();
    if (!trimmedDistributorName) {
      return;
    }

    console.log("Dist Name: ", trimmedDistributorName);
    setConfirmLoading(true);
    setConfirmLoading(false);
    setShowNewDistributorModal(false);
    setDistributorName("");
    navigate(
      `/Distributor?tab=details&distributorName=${encodeURIComponent(
        trimmedDistributorName
      )}`
    );
  };

  const handleSearch = async (val) => {
    const keyword = (val || "").trim();
    setSearchKeyword(keyword);
    if (keyword === "") {
      requestIdRef.current += 1;
      setCurrentPage(1);
      return;
    }
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `search?screen=DistributorDashboard&word=${encodeURIComponent(keyword)}`
      );
      if (requestId !== requestIdRef.current) return;
      const tempDists = response?.data?.data ?? [];
      setTotalCount(response?.data?.totalCount ?? tempDists.length);
      setTotalPages(
        response?.data?.totalPages ?? Math.ceil(tempDists.length / pageSize)
      );
      setDistributorData(normalizeDistributors(tempDists));
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  const handlePaginationChange = (page, size) => {
    const nextSize = size || pageSize;
    const sizeChanged = nextSize !== pageSize;
    if (sizeChanged) {
      setPageSize(nextSize);
      setCurrentPage(1);
      return;
    }
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const isActiveFlag = (value) =>
    value === true || value === 1 || value === "1" || value === "true";

  const isInactiveFlag = (value) =>
    value === false || value === 0 || value === "0" || value === "false";

  const activeInactiveDistributorData = useMemo(() => {
    if (selectedSegment === "Active") {
      return distributorData?.filter((dist) => isActiveFlag(dist?.IsActive));
    } else if (selectedSegment === "Inactive") {
      return distributorData?.filter((dist) => isInactiveFlag(dist?.IsActive));
    }
    return distributorData;
  }, [selectedSegment, distributorData]);

  return (
    <div>
      <TitleBar
        label="Distributors"
        invoiceNumber={
          loading ? (
            <Skeleton.Avatar
              active
              shape="circle"
              size={24}
              style={{ width: 24 }}
            />
          ) : searchKeyword ? (
            activeInactiveDistributorData?.length || 0
          ) : (
            totalCount
          )
        }
        filterBarComponents={
          <>
            <CommonButton
              isActive={selectedSegment === "Active"}
              variant="timeframe"
              onClick={() => handleSegmentChange("Active")}
            >
              Active
            </CommonButton>
            <CommonButton
              isActive={selectedSegment === "Inactive"}
              variant="timeframe"
              onClick={() => handleSegmentChange("Inactive")}
            >
              Inactive
            </CommonButton>
          </>
        }
        rightFilterBarComponents={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <Input.Search
              placeholder="Search"
              // suffix={<SearchOutlined />}
              allowClear
              style={{ height: "36px" }}
              onChange={(e) => {
                if (e.target.value === "") {
                  handleSearch("");
                }
              }}
              // onSearch={value => setSearchKeyword(value)}
              onSearch={(value) => handleSearch(value)}
            />
            {userType !== "Viewer" && hasPermission(user, "manage_distributors.add") && (
              <Button
                type="primary"
                onClick={() => setShowNewDistributorModal(true)}
                style={{ background: colors["primaryColor"] }}
                icon={<PlusOutlined />}
                iconPosition="start"
              >
                New
              </Button>
            )}
          </div>
        }
      />
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}

      {!loading && (
        <>
          <CommonTable
            rowData={activeInactiveDistributorData}
            columnDefs={tableHeadersDistributorDashboard}
            pagination={false}
          />
          {searchKeyword === "" && totalCount > 0 && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalCount}
                showSizeChanger
                showQuickJumper
                pageSizeOptions={["20", "50", "100"]}
                onChange={handlePaginationChange}
                onShowSizeChange={handlePaginationChange}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total}`
                }
              />
            </div>
          )}
        </>
      )}

      <Modal
        title="New Distributor"
        open={showNewDistributorModal}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        centered={true}
        footer={false}
      >
        <label htmlFor="DistributorName" className="form-input-label">
          Distributor Name
        </label>
        <Input
          id="DistributorName"
          name="DistributorName"
          placeholder="Enter Distributor Name"
          value={distributorName}
          onChange={handleInputChange}
        />
        <p>
          You will be redirected to fill out the remaining distributor details
          once you have added the account.
        </p>
        <Button
          type="primary"
          onClick={handleOk}
          disabled={!distributorName.trim()}
          style={{ background: "#27a907" }}
        >
          Add Distributor
        </Button>
      </Modal>
    </div>
  );
};

export default DistributorDashboard;
